module.exports = __webpack_public_path__ + "img/regpack-inactive.cee0dc56.svg";